import { render, staticRenderFns } from "./ComOverview.vue?vue&type=template&id=6f08653e&scoped=true&"
import script from "./ComOverview.vue?vue&type=script&lang=js&"
export * from "./ComOverview.vue?vue&type=script&lang=js&"
import style0 from "./ComOverview.vue?vue&type=style&index=0&id=6f08653e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f08653e",
  null
  
)

export default component.exports